export default "__VITE_ASSET__26FwYQgW__"